<template>
    <div class="basicData" v-wechat-title="$t('添加/编辑服务类型')">
        <Title :title="$t('添加/编辑服务类型')"/>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span class="has_must">{{ $t('服务类型') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.name" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span></span></div>
                    <div class="input_box">

                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span></span></div>
                    <div class="input_box">

                    </div>
                </div>
            </div>
        </div>
        <div class="edit_btn_box">
            <button type="button" class="back_btn" @click="$router.go(-1)">{{ $t('返回') }}</button>
            <button type="button" class="save_btn" @click="save" v-permissions="26030401" v-noClick>{{ $t('保存') }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                optionsOne: [],
                options: [],
                parameters: {
                    name: ''
                }
            }
        },
        mounted () {
            this.initMounted()
        },
        methods: {
            initMounted () {
                if (this.$route.query.id) this.read()
            },
            save () {
                if (!this.parameters.name) {
                    this.$message.info(this.$t('请填写必填信息'))
                    return false
                }
                this.$store.dispatch(this.$route.query.id ? 'a:maintainServiceType/update' : 'a:maintainServiceType/create', this.parameters).then(
                    res => {
                        this.$message.success(this.$t('保存成功'));
                        this.$router.go(-1)
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            read () {
                this.$store.dispatch('a:maintainServiceType/detail', {id: this.$route.query.id}).then(
                    res => {
                        this.parameters = res
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
